// extracted by mini-css-extract-plugin
export default {"component":"Modal_component__MhLBn","modal":"Modal_modal__YwX8Y","header":"Modal_header__CBqFj","body":"Modal_body__GY4sh","footer":"Modal_footer__fEVau"};